import { Component, OnInit, Input, ElementRef } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { Location } from '@angular/common';
import axios from 'src/app/Service/axios';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
declare let $: any;

@Component({
  selector: 'car-area',
  templateUrl: './car-area.component.html'
})
export class CarAreaComponent implements OnInit {
  Id: number = 0;
  pastArea: any;
  geoFenceUsgae: any;
  GeoFenceData: any;
  saveGeoFence: FormGroup = this.formBuilder.group({
    strSession: new FormControl(`${this.gurdService.decrypt(localStorage.getItem('Session')!)}`),
    iSystemUser: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('ID')!)),
    strUnitID: new FormControl(this.Id),
    iGeoFence: new FormControl(-1),
    tiGeoFenceUsgae: new FormControl(-1),
    strSTime: new FormControl("00:00"),
    strETime: new FormControl("23:59"),
    bSendSMS: new FormControl(false),
    bSendPush: new FormControl(false),
  });
  constructor(private el: ElementRef,
    private notifyService: NotificationService,
    private router: Router,
    private otherService: OtherService,
    private _location: Location,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private gurdService: GurdServiceService
  ) { }
  ngOnInit(): void {
    //timePicker
    $('.clockpicker').clockpicker({
      donetext: 'top',
      align: 'top',
      autoclose: true,
    });
    this.route.params.subscribe(params => {
      this.Id = params['id'];
      this.getPastArea();
      this.GeoFenceUsgae();
      this.getArea();
      this.saveGeoFence.controls["strUnitID"].setValue(this.Id);
    });
  }
  goBack() {
    this._location.back();
  }
  getPastArea = async () => {
    var model = {
      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strUnitID: this.Id,
    };

    const resp = await axios.post(`Radyab_GetMobileGeoFence`, model);
    this.pastArea = JSON.parse(resp.data);
  }
  SaveMobileGeoFence = async () => {
    var model = this.saveGeoFence.value;

    var Stime = document.getElementById("Stime") as any;
    model.strSTime = Stime.value;
    var Etime = document.getElementById("Etime") as any;
    model.strETime = Etime.value;

    if (model.iGeoFence == -1) {
      this.notifyService.showError("لطفا نام محدوده را وارد کنید");
      return;
    }
    if (model.tiGeoFenceUsgae == -1) {
      this.notifyService.showError("لطفا کاربری  را وارد کنید");
      return;
    }
    const resp = await axios.post(`Radyab_SaveMobileGeoFence`, model);
    let resParse = JSON.parse(resp.data);
    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;
    }
    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '10' } });

      return;
    }
    else {
      this.notifyService.showSuccess("با موفقیت ثبت شد");
      this.getPastArea();
      this.saveGeoFence.reset({
        strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
        iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
        strUnitID: this.Id,
        iGeoFence: -1,
        tiGeoFenceUsgae: -1,
        strSTime: "00:00",
        strETime: "23:59",
        bSendSMS: false,
        bSendPush: false,
      });
    }

  }
  deleteArea = async (id: any) => {
    $.confirm({
      title: `آیا از حذف این محدوده اطمینان دارید ؟`,
      content: '',
      type: 'red',
      buttons: {
        ok: {
          text: "حذف",
          btnClass: 'btn-success',
          keys: ['enter'],
          action: async () => {
            var model = {
              strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
              iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
              iMobileGeoFences: id,
            };

            const resp = await axios.post(`Radyab_DeleteMobileGeoFence`, model);
            let resParse = JSON.parse(resp.data);
            if (resParse.iResult == 0) {
              this.notifyService.showError(resParse.strError);
              return;
            }
            if (resParse.ISSessionExpired == true) {
              this.notifyService.showError('لطفا وارد سیستم شوید');
              this.otherService.removeLocalStorage();
              // this.router.navigate(['login']);
              this.router.navigate(['login'], { queryParams: { error: '11' } });

              return;
            }
            else {
              this.notifyService.showSuccess("با موفقیت حذف شد");
              this.pastArea = this.pastArea.filter((el: any) => {
                return el.iMobileGeoFences != id;
              });
            }
            return;

          }
        },
        cancel: {
          text: "لغو",

        }
      }
    });



  }
  GeoFenceUsgae = async () => {
    const resp = await axios.post(`Radyab_GetGeoFenceUsgae`, {});
    this.geoFenceUsgae = resp.data;
  }
  getArea = async () => {
    var model = {
      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
    };
    const resp = await axios.post(`Radyab_GeoFence`, model);
    let respJson = JSON.parse(resp.data);
    this.GeoFenceData = respJson;
  };

}


